// extracted by mini-css-extract-plugin
module.exports = {"container":"simLogo_container__3pLfD","icon":"simLogo_icon__i4yRf"};